
class PlugStickyHeaderWrapper extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.headerSection = document.querySelector(".plug-header-section");
        this.headerBounds = {};

        this.setHeaderHeight();

        window.matchMedia("(max-width: 990px)").addEventListener("change", this.setHeaderHeight.bind(this));

        this.currentScrollTop = 0;
        this.preventReveal = false;
        this.preventHide = false;

        this.onScrollHandler = this.onScroll.bind(this);
        this.hideHeaderOnScrollUp = () => this.preventReveal = true;

        this.addEventListener("preventHeaderReveal", this.hideHeaderOnScrollUp);
        window.addEventListener("scroll", this.onScrollHandler, false);

        this.createObserver();
    }

    setHeaderHeight() {
        document.documentElement.style.setProperty("--plug-header-height", `${this.headerSection.offsetHeight}px`);
    }

    disconnectedCallback() {
        this.removeEventListener("preventHeaderReveal", this.hideHeaderOnScrollUp);
        window.removeEventListener("scroll", this.onScrollHandler);
    }

    createObserver() {
        let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
        });

        observer.observe(this.headerSection);
    }

    onScroll() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.headerSection.classList.add("scrolled-past-header");
            if (this.preventHide) return;
            requestAnimationFrame(this.hide.bind(this));
        } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.headerSection.classList.add("scrolled-past-header");
            if (!this.preventReveal) {
                requestAnimationFrame(this.reveal.bind(this));
            } else {
                window.clearTimeout(this.isScrolling);

                this.isScrolling = setTimeout(() => {
                    this.preventReveal = false;
                }, 66);

                requestAnimationFrame(this.hide.bind(this));
            }
        } else if (scrollTop <= this.headerBounds.top) {
            this.headerSection.classList.remove("scrolled-past-header");
            requestAnimationFrame(this.reset.bind(this));
        }

        this.currentScrollTop = scrollTop;
    }

    hide() {
        this.headerSection.classList.add("plug-header-section-hidden", "plug-header-section-sticky");
        this.closeMenuDisclosure();
        this.closeSearchModal();
    }

    reveal() {
        this.headerSection.classList.add("plug-header-section-sticky", "animate");
        this.headerSection.classList.remove("plug-header-section-hidden");
    }

    reset() {
        this.headerSection.classList.remove("plug-header-section-hidden", "plug-header-section-sticky", "animate");
    }

    closeMenuDisclosure() {
        // @todo
    }

    closeSearchModal() {
        // @todo
    }
}
if (!customElements.get("plug-sticky-header-wrapper")) {
    customElements.define("plug-sticky-header-wrapper", PlugStickyHeaderWrapper);
}

class PlugHeader extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.elements = {
            desktopL1ListItems: Array.from(this.getElementsByClassName("plug-header-menu__l1")),
            desktopL1Links: Array.from(this.getElementsByClassName("plug-header-menu__l1-link")),
            headerBar: this.querySelector(".plug-header__bar"),
            headerSection: this.closest(".plug-header-section"),
            megaMenus: Array.from(this.getElementsByClassName("plug-header__mega-menu")),
            menuButton: this.querySelector(".plug-header__icon-item--menu .plug-header__icon-button"),

            // mobileMenu: this.querySelector("plug-mobile-menu"),

            searchButtons: Array.from(this.querySelectorAll(".plug-header__icon-item--search .plug-header__icon-button")),
            searchInput: this.querySelector(".plug-header__search-input"),
            searchOverlayCloseButton: this.querySelector(".plug-header__search-overlay-close"),
            searchOverlay: this.querySelector(".plug-header__search-overlay"),
            searchResetButton: this.querySelector(".plug-header__search-reset"),
        };

        // Only transparent when header is in initial position (not when sticky).
        this.hasTransparentBg = (this.dataset.hasTransparentBg === "true");

        this.openMegaMenuId = undefined;

        this.initListeners();
    }

    initListeners() {

        // Search listeners.

        this.elements.searchButtons.forEach(button => {
            button.addEventListener("click", (e) => {
                if (this.isBoostMobile()) {
                    this.elements.searchInput.click();
                } else {
                    this.elements.searchOverlay.classList.remove("is-hidden");
                    this.elements.searchInput.focus();
                }
            });
        });

        this.elements.searchInput.addEventListener("input", (e) => {
            if (e.target.value.length > 0) {
                this.elements.searchResetButton.classList.remove("is-hidden");
            } else {
                this.elements.searchResetButton.classList.add("is-hidden");
            }
        });

        this.elements.searchResetButton.addEventListener("click", (e) => {
            this.elements.searchInput.value = "";
        });

        this.elements.searchOverlayCloseButton.addEventListener("click", (e) => {
            this.elements.searchOverlay.classList.add("is-hidden");
        });

        // Mega menu listeners.

        this.elements.desktopL1Links.forEach((link, l1LinkIndex) => {
            const listItem = link.closest(".plug-header-menu__l1");
            const megaMenuId = listItem.dataset.megaMenuId;
            const megaMenu = document.getElementById(megaMenuId);
            let leaveTimeout;

            const handleMouseLeave = () => {
                leaveTimeout = setTimeout(() => {
                    listItem.classList.remove("is-active");
                    this.closeMegaMenu(megaMenuId);
                }, 100);
            };

            link.addEventListener("mouseenter", () => {
                clearTimeout(leaveTimeout);
                this.openMegaMenuId = megaMenuId;
                this.elements.headerSection.classList.add("plug-force-bg");
                listItem.classList.add("is-active");
                if (megaMenu && megaMenu.classList.contains("is-open")) {
                    return;
                }
                if (megaMenu) {
                    this.openMegaMenu(megaMenu);
                    this.closeAllMegaMenus(megaMenuId);
                }
            });

            if (megaMenu) {
                megaMenu.addEventListener("mouseenter", () => {
                    clearTimeout(leaveTimeout);
                });

                megaMenu.addEventListener("mouseleave", () => {
                    handleMouseLeave();
                });
            }

            link.addEventListener("mouseleave", handleMouseLeave);

            link.addEventListener("keydown", (e) => {
                if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    this.openMegaMenuId = megaMenuId;
                    this.elements.headerSection.classList.add("plug-force-bg");
                    listItem.classList.add("is-active");
                    if (megaMenu && !megaMenu.classList.contains("is-open")) {
                        this.openMegaMenu(megaMenu, true);
                        link.setAttribute("aria-expanded", "true");
                        this.closeAllMegaMenus(megaMenuId);
                    }
                } else if (e.key === "ArrowLeft" || e.key === "ArrowRight") {
                    if (e.key === "ArrowRight") {
                        if (l1LinkIndex < this.elements.desktopL1Links.length - 1) {
                            e.preventDefault();
                            this.elements.desktopL1Links[l1LinkIndex + 1].focus();
                        } else if (l1LinkIndex === this.elements.desktopL1Links.length - 1) {
                            e.preventDefault();
                            this.elements.desktopL1Links[0].focus(); // Loop to first link
                        }
                    } else if (e.key === "ArrowLeft") {
                        if (l1LinkIndex > 0) {
                            e.preventDefault();
                            this.elements.desktopL1Links[l1LinkIndex - 1].focus();
                        } else if (l1LinkIndex === 0) {
                            e.preventDefault();
                            this.elements.desktopL1Links[this.elements.desktopL1Links.length - 1].focus(); // Loop to last link
                        }
                    }
                }
            });

            if (megaMenu) {
                megaMenu.addEventListener("keydown", (e) => {
                    if (e.key === "ArrowDown" || e.key === "ArrowUp") {
                        const currentlyFocused = document.activeElement;
                        const links = megaMenu.querySelectorAll("a");
                        const currentIndex = Array.from(links).indexOf(currentlyFocused);
                        if (currentIndex >= 0) {
                            if (e.key === "ArrowDown") {
                                if (currentIndex < links.length - 1) {
                                    e.preventDefault();
                                    links[currentIndex + 1].focus();
                                } else if (currentIndex === links.length - 1) {
                                    e.preventDefault();
                                    links[0].focus(); // Loop to first link
                                }
                            } else if (e.key === "ArrowUp") {
                                if (currentIndex > 0) {
                                    e.preventDefault();
                                    links[currentIndex - 1].focus();
                                } else if (currentIndex === 0) {
                                    e.preventDefault();
                                    links[links.length - 1].focus(); // Loop to last link
                                }
                            }
                        }
                    } else if (e.key === "Escape") {
                        e.preventDefault();
                        this.closeMegaMenu(megaMenuId);
                        listItem.classList.remove("is-active");
                        link.focus(); // Return focus to the link that opened the menu
                    }
                });
            }
        });
    }

    openMegaMenu(megaMenu, focusFirstLink = false) {
        megaMenu.classList.remove("is-hidden");
        requestAnimationFrame(() => {
            setTimeout(() => {
                megaMenu.classList.add("is-open");
                if (focusFirstLink) {
                    const firstLink = this.findFirstMegaMenuLink(megaMenu);
                    if (firstLink) {
                        firstLink.focus();
                    }
                }
            }, 0);
        });
    }

    closeAllMegaMenus(excludeId) {
        this.elements.desktopL1ListItems.forEach(listItem => {
            if (listItem.dataset.megaMenuId !== excludeId) {
                this.closeMegaMenu(listItem.dataset.megaMenuId);
            }
        });
    }

    closeMegaMenu(id) {
        if (id === this.openMegaMenuId) {
            this.openMegaMenuId = undefined;
            setTimeout(() => {
                if (!this.openMegaMenuId) {
                    this.elements.headerSection.classList.remove("plug-force-bg");
                }
            }, 200);
        }
        const megaMenu = document.getElementById(id);
        if (!megaMenu) return;
        const link = this.elements.desktopL1Links.find(link => link.dataset.megaMenuId === id);
        if (link) {
            link.setAttribute("aria-expanded", "false");
        }
        megaMenu.classList.remove("is-open");
        megaMenu.classList.add("is-hidden");
    }

    isBoostMobile() {
        return window.innerWidth < 992;
    }

    findFirstMegaMenuLink(megaMenu) {
        return megaMenu.querySelector("a");
    }
}

if (!customElements.get("plug-header")) {
    customElements.define("plug-header", PlugHeader);
}

class PlugMobileMenu extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.elements = {
            header: this.closest("plug-header"),
            headerSection: this.closest(".plug-header-section"),
            l1Buttons: Array.from(this.getElementsByClassName("plug-mobile-menu__l1-link")),
            l2Buttons: Array.from(this.getElementsByClassName("plug-mobile-menu__l2-link")),
            menuButton: document.querySelector(".plug-header__icon-item--menu .plug-header__icon-button"),
            overlay: this.querySelector(".plug-mobile-menu__overlay"),
            submenuBackButtons: Array.from(this.getElementsByClassName("plug-mobile-menu__back-button")),
        };

        this.initListeners();
    }

    initListeners() {
        this.elements.overlay.addEventListener("click", (e) => {
            this.close();
        });

        this.elements.menuButton.addEventListener("click", (e) => {
            const isOpen = this.elements.menuButton.classList.contains("is-active");
            if (isOpen) {
                this.close();
            } else {
                this.open();
            }
        });

        this.elements.l1Buttons.forEach(l1Button => {
            const submenu = document.getElementById(l1Button.dataset.submenuId);
            if (submenu) {
                l1Button.addEventListener("click", () => {
                    l1Button.setAttribute("aria-expanded", "true");
                    this.openSubmenu(submenu);
                });
            }
        });

        this.elements.submenuBackButtons.forEach(backButton => {
            const submenu = backButton.closest(".plug-mobile-menu__submenu");
            const l1Button = this.elements.l1Buttons.find(button => button.dataset.submenuId === submenu.id);
            backButton.addEventListener("click", (e) => {
                if (l1Button) {
                    l1Button.setAttribute("aria-expanded", "false");
                }
                this.closeSubmenu(submenu);
            });
        });

        this.elements.l2Buttons.forEach(l2Button => {
            l2Button.addEventListener("click", (e) => {
                const l2 = l2Button.closest(".plug-mobile-menu__l2");
                const l3List = l2.querySelector(".plug-mobile-menu__l3-list");
                if (!l2.classList.contains("is-open")) {
                    l3List.classList.remove("is-hidden");
                    requestAnimationFrame(() => {
                        setTimeout(() => {
                            l2.classList.add("is-open");
                        }, 0);
                    });
                } else {
                    l3List.classList.add("is-hidden");
                    l2.classList.remove("is-open");
                }
            });
        });

        this.initResizeListener();

        this.addEventListener("keydown", (e) => {
            if (e.key === "ArrowDown" || e.key === "ArrowUp" || e.key === "Tab") {
                e.preventDefault();
                const activeElement = document.activeElement;
                const activeMenu = (
                    activeElement.closest(".plug-mobile-menu__submenu")
                        ? activeElement.closest(".plug-mobile-menu__submenu")
                        : this.querySelector(".plug-mobile-menu__main-menu")
                );
                const focusableElements = Array.from(
                    activeMenu.querySelectorAll("a, button")
                ).filter(el => !el.closest(".is-hidden"));
                const index = focusableElements.indexOf(activeElement);
                if (index >= 0) {
                    if (e.key === "ArrowDown" || (e.key === "Tab" && !e.shiftKey)) {
                        if (index < focusableElements.length - 1) {
                            focusableElements[index + 1].focus();
                        } else {
                            focusableElements[0].focus(); // Loop to first element
                        }
                    } else {
                        if (index > 0) {
                            focusableElements[index - 1].focus();
                        } else {
                            focusableElements[focusableElements.length - 1].focus(); // Loop to first element
                        }
                    }
                }
            } else if (e.key === "Escape") {
                e.preventDefault();
                const activeSubmenu = this.querySelector(".plug-mobile-menu__submenu.is-open");
                if (activeSubmenu) {
                    this.closeSubmenu(activeSubmenu);
                }
                this.close();
            }
        });
    }

    initResizeListener() {
        let resizeTimeout = undefined;
        const handleResize = () => {
            this.style.top = `${this.elements.header.getBoundingClientRect().bottom}px`;
            if (!this.isMobile()) {
                this.close();
            }
        };

        window.addEventListener("resize", () => {
            if (this.elements.menuButton.classList.contains("is-active")) {
                clearTimeout(resizeTimeout);
                resizeTimeout = setTimeout(() => {
                    handleResize();
                }, 200);
            }
        });
    }

    open() {
        this.style.top = `${this.elements.header.getBoundingClientRect().bottom}px`;
        document.body.classList.add("plug-no-scroll");
        this.elements.menuButton.classList.add("is-active");
        this.classList.remove("is-hidden");
        this.elements.headerSection.classList.add("plug-force-bg");
        requestAnimationFrame(() => {
            setTimeout(() => {
                this.classList.add("is-open");
            }, 0);
        });
        const smileUiContainer = document.querySelector("#smile-ui-container");
        if (smileUiContainer) {
            smileUiContainer.classList.add("is-hidden");
        }
    }

    close() {
        this.elements.menuButton.classList.remove("is-active");
        this.classList.remove("is-open");
        document.body.classList.remove("plug-no-scroll");
        setTimeout(() => {
            this.classList.add("is-hidden");
            const smileUiContainer = document.querySelector("#smile-ui-container");
            if (smileUiContainer) {
                smileUiContainer.classList.remove("is-hidden");
            }
            this.elements.headerSection.classList.remove("plug-force-bg");
        }, 150);
    }

    openSubmenu(submenu) {
        submenu.classList.remove("is-hidden");
        const links = submenu.querySelectorAll("a, button");
        requestAnimationFrame(() => {
            setTimeout(() => {
                submenu.classList.add("is-open");
                setTimeout(() => {
                    if (links[0]) {
                        links[0].focus(); // Focus the first link in the submenu
                    }
                }, 300);
            }, 0);
        });
    }

    closeSubmenu(submenu) {
        submenu.classList.remove("is-open");
        const l1Button = this.elements.l1Buttons.find(button => button.dataset.submenuId === submenu.id);
        if (l1Button) {
            l1Button.focus(); // Return focus to the L1 button that opened the submenu
        }
        setTimeout(() => {
            submenu.classList.add("is-hidden");
        }, 150);
    }

    isMobile() {
        return window.innerWidth < 1200;
    }
}
if (!customElements.get("plug-mobile-menu")) {
    customElements.define("plug-mobile-menu", PlugMobileMenu);
}
